// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"88":"df55b752334be01e7e4d","243":"307c1cf31df043fbcfea","615":"e1c97e1d82c038fc39f8","682":"010d3484390bfdcb1778","688":"1c990d7d3fa5b3eae90f","852":"a2e9235d30d6687e5ceb","951":"e112a1540854a300343e"}[chunkId] + ".bundle.js";
};